<script setup lang="ts">
definePageMeta({
    hidePromotions: true
})

const { data: pageData } = await usePageData('blog')

const blogPosts = await useBlogPosts()
const posts = computed(() => blogPosts.data.value ?? [])
</script>

<template>
    <PageBlog :page-data="pageData" :posts="posts" />
</template>
